import { jsxs, jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import cns from '../../../../node_modules/classnames/index.js';
import FeedbackIcon from '../../../GoogleIcons/Filled/FeedbackIcon.js';
import QuestionAnswerIcon from '../../../GoogleIcons/Filled/QuestionAnswerIcon.js';
import ThumbUpIcon from '../../../GoogleIcons/Filled/ThumbUpIcon.js';
import ReportIcon from '../../../GoogleIcons/Filled/ReportIcon.js';
import { EmphasisLM } from '../../../types.js';
export { Emphasis as FeedbackPanelEmphasis } from '../../../types.js';

var FeedbackPanelType;
(function (FeedbackPanelType) {
    FeedbackPanelType["info"] = "info";
    FeedbackPanelType["alarm"] = "alarm";
    FeedbackPanelType["warning"] = "warning";
    FeedbackPanelType["success"] = "success";
    FeedbackPanelType["successPartial"] = "success-partial";
})(FeedbackPanelType || (FeedbackPanelType = {}));
/**
Pannello per chiedere la conferma di lettura di un messaggio.

Vedi [Design System di CGN - Feedback](https://zeroheight.com/1b5e94371/p/34fc2c-feedback/b/95d71c)

L'icona può essere cambiata specificandone una ma è sempre meglio farlo in accordo con la UX, le icone utilizzabili devono comunque essere "filled".
*/
function FeedbackPanel({ type = FeedbackPanelType.info, title, message, emphasis = EmphasisLM.LOW, icon, }) {
    const Icon = useMemo(() => {
        if (icon) {
            return icon;
        }
        if (type === FeedbackPanelType.success || type === FeedbackPanelType.successPartial) {
            return ThumbUpIcon;
        }
        if (type === FeedbackPanelType.warning) {
            return FeedbackIcon;
        }
        if (type === FeedbackPanelType.alarm) {
            return ReportIcon;
        }
        return QuestionAnswerIcon;
    }, [icon, type]);
    return (jsxs("div", { className: cns('v2-feedback-panel', `v2-feedback-panel--${type}`, `v2-feedback-panel--emphasis-${emphasis.toLowerCase()}`), children: [jsx(Icon, { className: "v2-feedback-panel__icon" }), jsxs("div", { className: "v2-feedback-panel__content", children: [jsx("h1", { children: title }), jsx("div", { className: "v2-feedback-panel__message", children: message })] })] }));
}
FeedbackPanel.Emphasis = EmphasisLM;

export { FeedbackPanelType, FeedbackPanel as default };
